var NavigationToolbarUI = function () {

    var mainNavigationToolbarUILogic = function (id) {

        var $elem = $(id);

        if ($(window).width() < 768) {
            $elem.accordion({ collapsible: true, active: 1 });
            $elem.css({
                height: 'auto',
            });
        }
        if ($(window).width() >= 768) {
            $elem.accordion({ collapsible: false });
            /*
            var realHeight = 0;
            $(id).find('.ui-accordion-content > div').each(function () {
                realHeight += $(this).height();
            })
            */
            $elem.find('.ui-accordion-content')
                .height('100%')
                .show();
            $elem.height('auto');
        }

    };

    return {

        toggleToolbar: function (domId) {
            mainNavigationToolbarUILogic(domId);
            $(window).resize(function () {
                mainNavigationToolbarUILogic(domId);
            });

        }
    }
};